import React, { memo } from "react";
import AerosNode from "./AerosNode";

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="tag" selected={selected} isConnectable={isConnectable}>
    {data.tag?.name}
  </AerosNode>
));
